import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Input, Row, Select, Space, Table, Tag, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import dietaryPreferencesData from '../utils/dietaryPreferences.json'

const { Title, Text } = Typography
const { Option } = Select

const DietaryPreferences = ({ data, setData }) => {
  const [selectedDietType, setSelectedDietType] = useState('')
  const [selectedRestrictions, setSelectedRestrictions] = useState([])
  const [customNote, setCustomNote] = useState('')

  const dietTypes = dietaryPreferencesData.dietTypes
  const dietaryRestrictions = dietaryPreferencesData.restrictions

  const handleAddDietaryPreference = () => {
    if (selectedDietType) {
      const newPreference = {
        id: Date.now(),
        dietType: selectedDietType,
        restrictions: selectedRestrictions,
        notes: customNote
      }

      setData([...data, newPreference])

      // Reset form
      setSelectedDietType('')
      setSelectedRestrictions([])
      setCustomNote('')
    }
  }

  const handleRemovePreference = (id) => {
    setData(data.filter((item) => item.id !== id))
  }

  const columns = [
    {
      title: 'Diet Type',
      dataIndex: 'dietType',
      key: 'dietType',
      render: (text) => <Tag color='blue'>{text}</Tag>
    },
    {
      title: 'Restrictions',
      dataIndex: 'restrictions',
      key: 'restrictions',
      render: (restrictions) => (
        <span>
          {restrictions.map((restriction) => (
            <Tag color='red' key={restriction}>
              {restriction}
            </Tag>
          ))}
        </span>
      )
    },
    {
      title: 'Notes',
      dataIndex: 'notes',
      key: 'notes'
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button
          danger
          icon={<FontAwesomeIcon icon={faTrash} />}
          onClick={() => handleRemovePreference(record.id)}
          size='small'
        />
      )
    }
  ]

  return (
    <div>
      <Title level={4}>Dietary Preferences & Restrictions</Title>
      <Text>Set the patient's dietary preferences and any food restrictions or allergies.</Text>

      <Card style={{ marginTop: 16, marginBottom: 16 }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Text strong>Diet Type</Text>
            <Select
              placeholder='Select diet type'
              style={{ width: '100%' }}
              value={selectedDietType}
              onChange={(value) => setSelectedDietType(value)}
            >
              {dietTypes.map((diet) => (
                <Option key={diet.name} value={diet.name}>
                  {diet.name}
                </Option>
              ))}
            </Select>
          </Col>

          <Col xs={24} md={12}>
            <Text strong>Restrictions & Allergies</Text>
            <Select
              mode='multiple'
              placeholder='Select restrictions'
              style={{ width: '100%' }}
              value={selectedRestrictions}
              onChange={(value) => setSelectedRestrictions(value)}
            >
              {dietaryRestrictions.map((restriction) => (
                <Option key={restriction} value={restriction}>
                  {restriction}
                </Option>
              ))}
            </Select>
          </Col>

          <Col span={24}>
            <Text strong>Additional Notes</Text>
            <Input.TextArea
              rows={4}
              placeholder='Enter any additional dietary notes or specific instructions'
              value={customNote}
              onChange={(e) => setCustomNote(e.target.value)}
            />
          </Col>

          <Col span={24}>
            <Button
              type='primary'
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={handleAddDietaryPreference}
              disabled={!selectedDietType}
            >
              Add Dietary Preference
            </Button>
          </Col>
        </Row>
      </Card>

      <Table dataSource={data} columns={columns} rowKey='id' pagination={false} size='small' />
    </div>
  )
}

export default DietaryPreferences
